import React, { useState, useEffect, useMemo } from 'react';
import { differenceBy } from 'lodash';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Nothing from 'components/Misc/Nothing';
import Progress from 'components/Misc/Progress';
import { Select, Button } from 'components/Misc/Form';

import Course from 'containers/Administrator/Blanks/Create/Courses/Course';

import { useBlankCreateStore } from 'store/blank/useBlankCreateStore';

const Add = ({ modal, handleModal }) => {
	// Use blank's creation store
	const selected = useBlankCreateStore(state => state.blank.courses);

	// Store search parameters
	const [search, setSearch] = useState({
		subjectId: 0
	});

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[subject]',
		subjectId: search.subjectId
	}), [search]);

	// Store collected subjects
	const [[subjects], collectSubjects] = useCollect('subjects');

	// Store collected courses
	const [[courses, progress], collectCourses] = useCollect('courses', parameters);

	// Store available courses
	const available = useMemo(() =>
		differenceBy(courses, selected, 'id') || []
	, [courses, selected]);

	// Handles search field's onChange event
	// @event: object | native onChange event
	const onChange = ({ name, value }) => {
		setSearch(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Collect subjects on mount
	useEffect(() => {
		(async () => await collectSubjects())();
	}, [collectSubjects]);

	// Collect courses on subject selection
	useEffect(() => {
		if (!search.subjectId) return;
		(async () => await collectCourses())();
	}, [search, collectCourses]);

	return (
		<Modal title="Pievienot moduli" visible={modal} handleModal={handleModal}>
			<div className="space-y-4">
				{/* Filter courses by subject */}
				<Select
					name="subjectId"
					placeholder="Izvēlēties mācību kursu"
					value={search.subjectId}
					onChange={onChange}
					options={subjects?.map(subject => ({
						value: subject.id,
						name: subject.title
					}))}
				/>

				{/* List available courses for selection */}
				<Show if={available.length && !progress}>
					<div className="grid md:grid-cols-2 gap-4">
						{available?.map(course =>
							<Course key={course.id} course={course} />
						)}
					</div>
				</Show>

				{/* Show loading progress */}
				<Progress progress={progress} />

				{/* Show nothing */}
				<Nothing visible={!available?.length && !progress} />

				{/* Modal's controls */}
				<div className="flex justify-end">
					<Button
						icon="check"
						theme="success"
						value="Saglabāt"
						onClick={handleModal}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Add;